import { Alert, Box, Typography } from '@mui/material'

import { SmartPayRecord } from 'types'

interface RecordItemProps {
  record: SmartPayRecord
  color: string
}

export const RecordItem = ({ record, color }: RecordItemProps) => {
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        backgroundColor: 'grey.50',
        borderRadius: 1,
        borderLeft: `4px solid ${color}`,
      }}>
      <Typography variant='caption' display='block'>
        <strong>Booking Ref:</strong> {record.bookingReference}
      </Typography>
      <Typography variant='caption' display='block'>
        <strong>Load Ref:</strong> {record.loadReference}
      </Typography>
      <Typography variant='caption' display='block'>
        <strong>Biller ID:</strong> {record.courierExchangeMemberId}
      </Typography>
      <Typography variant='caption' display='block'>
        <strong>Amount:</strong> £{record.gross.toFixed(2)} (Net: £{record.net.toFixed(2)}, VAT: £
        {record.vat.toFixed(2)})
      </Typography>
      {record.errorMessage && (
        <Alert severity='error' sx={{ mt: 1 }}>
          <Typography variant='caption'>{record.errorMessage}</Typography>
        </Alert>
      )}
    </Box>
  )
}
